import { Button, Logo, StripeBand } from '@/design/components';
import { UNKNOWN_PHONE_ERROR } from '@/lib/errors';
import { signOut } from './api';

/** יש סשן, אין רשומת עובד פעילה. אותו נוסח כמו מספר לא רשום. */
export function NoEmployeeRecord() {
  return (
    <div className="grid min-h-dvh grid-rows-[auto_1fr] bg-surface">
      <div className="bg-charcoal">
        <div className="flex h-32 items-center justify-center">
          <Logo on="charcoal" height={36} />
        </div>
        <StripeBand />
      </div>
      <main className="mx-auto grid w-full max-w-md content-start gap-6 p-4 pt-8">
        <h1 className="m-0 font-display text-display-l font-semibold">אין גישה</h1>
        <p className="m-0 text-body text-ink">{UNKNOWN_PHONE_ERROR}</p>
        <Button variant="secondary" onClick={() => void signOut()}>
          יציאה וכניסה עם מספר אחר
        </Button>
      </main>
    </div>
  );
}
